// src/features/subscription/utils/checkoutIntent.ts
//
// A visitor who picks a plan before having an account is sent to sign-up
// and comes back to /pricing. Remember what they picked so the checkout
// starts by itself once they are signed in, instead of asking them to find
// and click the plan a second time.

export interface CheckoutIntent {
  planKey: string;
  billing: 'monthly' | 'annual';
  /** PAYG pack key when the intent is a credit top-up rather than a plan. */
  payg?: string;
  createdAt: number;
}

const KEY = 'checkout:intent';
const MAX_AGE_MS = 30 * 60 * 1000; // half an hour is plenty for a sign-up

export function saveCheckoutIntent(intent: Omit<CheckoutIntent, 'createdAt'>): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ...intent, createdAt: Date.now() }));
  } catch {
    /* storage unavailable */
  }
}

export function readCheckoutIntent(): CheckoutIntent | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CheckoutIntent;
    if (!parsed?.planKey || Date.now() - (parsed.createdAt || 0) > MAX_AGE_MS) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearCheckoutIntent(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
}
